<template>
  <div class="home">
    <el-card shadow="always">
      <el-page-header
        @back="goBack"
        v-if="id === ''"
        content="Novo Usuário"
      ></el-page-header>
      <el-page-header
        @back="goBack"
        v-if="id !== ''"
        content="Atualizar Usuário"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        label-position="top"
        label-width="100px"
        ref="formRules"
        :model="formRules"
        :rules="rules"
      >
        <el-form-item label="Razão Social" prop="name">
          <el-input ref="name" v-model="formRules.name"></el-input>
        </el-form-item>
        <el-form-item label="Contato" prop="contact">
          <el-input v-model="formRules.contact"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="mail">
          <el-input
            type="email"
            pattern="^[^\s].+[^\s]+@[a-z0-9.-]+\.[a-z]{2,}$"
            v-model="formRules.mail"
            :disabled="id !== ''"
          ></el-input>
        </el-form-item>
        <el-form-item label="Senha" prop="password">
          <el-input
            type="password"
            v-model="formRules.password"
            :disabled="newPassword"
            show-password
          ></el-input>

          <el-button
            size="small"
            :type="id === '' || newPassword === true ? 'success' : 'danger'"
            @click="resetPassword"
          >
            <i class="el-icon-edit"></i>&nbsp;{{
              id !== ""
                ? newPassword
                  ? "Alterar Senha"
                  : "Remover senha"
                : "Gerar uma senha aleatória"
            }}
          </el-button>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Tipo" prop="type">
              <el-select v-model="formRules.type">
                <el-option label="Master" value="0"></el-option>
                <el-option label="Administrador" value="1"></el-option>
                <el-option label="Fornecedor" value="2"></el-option>
                <el-option label="Funcionário" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Permitir incluir nota fora do horário">
              <el-switch v-model="formRules.out"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="12" :sm="8" :md="6">
            <el-form-item label="CNPJ" prop="federalId">
              <el-input
                :disabled="formRules.type === '1' || formRules.type === '0'"
                v-model="formRules.federalId"
                v-mask="'##.###.###/####-##'"
              >
              </el-input>

              <el-button
                size="small"
                :disabled="formRules.type === '1' || formRules.type === '0'"
                :type="
                  formRules.type === '1' || formRules.type === '0'
                    ? 'info'
                    : 'success'
                "
                @click="addCnpj"
              >
                <i class="el-icon-plus"></i>&nbsp;Add outro CNPJ
              </el-button>
            </el-form-item>
          </el-col>

          <el-col
            v-for="(cnpj, index) in formRules.cnpjs"
            :key="cnpj.key"
            :xs="12"
            :sm="8"
            :md="6"
          >
            <el-form-item
              :rules="rules.cnpjs"
              :label="'CNPJ ' + (index + 2)"
              :prop="'cnpjs.' + index + '.value'"
            >
              <el-input
                :disabled="formRules.type === '1' || formRules.type === '0'"
                v-model="cnpj.value"
                v-mask="'##.###.###/####-##'"
              >
              </el-input>

              <el-button
                size="small"
                type="danger"
                @click.prevent="removeCnpj(cnpj)"
              >
                <i class="el-icon-delete"></i>&nbsp;Remover
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="add()" v-if="id === ''">
            <i class="el-icon-plus"></i>&nbsp;Adicionar
          </el-button>
          <el-button type="primary" @click="update()" v-if="id !== ''">
            <i class="el-icon-check"></i>&nbsp;Atualizar
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "../services/users/user.services";
import { mapGetters } from "vuex";

export default {
  name: "UsersAdd",
  components: {},
  data() {
    const checkArrayCnpj = (rule, value, callback) => {
      const vm = this;
      if (
        vm.formRules.type === UserTypeEnum.ADMIN ||
        vm.formRules.type === UserTypeEnum.MASTER
      ) {
        return callback();
      }
      if (value.length === 18) {
        return callback();
      }
      return callback(new Error("Iserir um CNPJ válido."));
    };

    const checkFederalId = (rule, value, callback) => {
      const vm = this;
      if (
        vm.formRules.type === UserTypeEnum.ADMIN ||
        vm.formRules.type === UserTypeEnum.MASTER
      ) {
        return callback();
      }
      if (!value) {
        return callback(
          new Error("Ao menos 1 CNPJ é obrigatório para este tipo de usuário.")
        );
      }
      if (value.length === 18) {
        return callback();
      }
      return callback(new Error("Inserir um CNPJ válido."));
    };

    const checkPassword = (rule, value, callback) => {
      const vm = this;
      if (vm.id !== "") {
        return callback();
      }

      if (!value) {
        return callback(new Error("Campo é obrigatório!"));
      }

      callback();
    };

    return {
      id: "",
      newPassword: false,
      formRules: {
        name: "",
        contact: "",
        mail: "",
        password: "",
        type: "1",
        federalId: "",
        out: false,
        cnpjs: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "Informe um nome",
            trigger: "blur",
          },
        ],
        contact: [
          {
            required: true,
            message: "Nome de contato",
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: "Informe um e-mail",
            trigger: "blur",
          },
        ],
        federalId: [
          {
            validator: checkFederalId,
            trigger: "blur",
          },
        ],
        cnpjs: [
          {
            validator: checkArrayCnpj,
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: checkPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    ...mapGetters("auth", ["getCompanyId"]),
    addCnpj() {
      const vm = this;
      vm.formRules.cnpjs.push({
        key: Date.now(),
        value: "",
      });
    },
    resetPassword() {
      const vm = this;
      if (vm.id === "") {
        vm.formRules.password = Math.random().toString(36).slice(-10);
      } else {
        vm.newPassword = !vm.newPassword;
        vm.formRules.password = "";
      }
    },
    removeCnpj(item) {
      const vm = this;
      let index = vm.formRules.cnpjs.indexOf(item);
      if (index !== -1) {
        vm.formRules.cnpjs.splice(index, 1);
      }
    },
    transformCnpj: function (cnpj) {
      cnpj = cnpj.replace(/\D/g, "");
      cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2");
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2");
      cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2");
      return cnpj;
    },
    goBack: function () {
      const vm = this;
      vm.$router.push({ name: "user" });
    },
    add: function () {
      const vm = this;
      this.$refs.formRules.validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          let federalId = `${vm.formRules.federalId.replace(/\D/g, "")};`;

          if (
            vm.formRules.type !== UserTypeEnum.ADMIN &&
            vm.formRules.type !== UserTypeEnum.MASTER
          ) {
            vm.formRules.cnpjs.forEach((cnpj) => {
              if (cnpj.value) {
                federalId += `${cnpj.value.replace(/\D/g, "")};`;
              }
            });
          }

          UserService.add(
            vm.formRules.name,
            vm.formRules.contact,
            vm.formRules.mail,
            vm.formRules.password,
            vm.formRules.type,
            federalId,
            vm.formRules.out,
            vm.getCompanyId()
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "Usuário criado com sucesso!",
              });
              this.$refs.formRules.resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Preencha os campos obrigatórios!",
          });
        }
      });
    },
    update: function () {
      const vm = this;
      this.$refs.formRules.validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          let federalId = `${vm.formRules.federalId.replace(/\D/g, "")};`;

          if (
            vm.formRules.type !== UserTypeEnum.ADMIN &&
            vm.formRules.type !== UserTypeEnum.MASTER
          ) {
            vm.formRules.cnpjs.forEach((cnpj) => {
              if (cnpj.value) {
                federalId += `${cnpj.value.replace(/\D/g, "")};`;
              }
            });
          }
          const password =
            vm.formRules.password.length > 0 ? vm.formRules.password : null;

          UserService.update(
            vm.id,
            vm.formRules.name,
            vm.formRules.contact,
            password,
            vm.formRules.type,
            federalId,
            vm.formRules.out
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "Usuário atualizado com sucesso!",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Preencha os campos obrigatórios!",
          });
        }
      });
    },
    get: function () {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.get(vm.id)
        .then((response) => {
          const federalId = response.user.federalId;
          if (federalId.indexOf(";") >= 0) {
            let string = federalId.substr(0, federalId.indexOf(";"));
            const inicio = string.length + 1;
            vm.formRules.federalId = this.transformCnpj(string);

            for (
              let i = inicio, count = 1, fim = federalId.indexOf(";");
              i < federalId.length;
              i += inicio, count++
            ) {
              string = federalId.substr(i, fim);
              vm.formRules.cnpjs.push({
                key: count,
                value: this.transformCnpj(string),
              });
            }
          } else {
            vm.formRules.federalId = this.transformCnpj(federalId);
          }

          vm.formRules.name = response.user.name;
          vm.formRules.contact = response.user.contact;
          vm.formRules.mail = response.user.mail;
          vm.formRules.type = response.user.type;
          vm.formRules.out = response.user.out;
          vm.formRules.password = "";
          vm.newPassword = true;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        if (
          response.user.type !== UserTypeEnum.ADMIN &&
          response.user.type !== UserTypeEnum.MASTER
        ) {
          vm.$router.push({ name: "home" });
        }
      })
      .catch(() => {
        vm.$router.push({ name: "home" });
      });

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.name.$el.children[0].focus();
    }
  },
};
</script>
